import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useEffect, useState } from 'react';
import LegacyUser, { LegacyUserEvents } from '@deezer/legacy-user';
import { useApiContext } from '@deezer/react-legacy-api';
import { createContext } from '@deezer/react-utils';
export { LegacyUser, LegacyUserEvents };
/**
 * Redirects user to account.deezer.com/missinginfo standalone
 */
const redirectToAccount = (hostAccount, path = 'missinginfo') => {
  const accountUrl = hostAccount.includes('https://') ? `${hostAccount}` : `https://${hostAccount}`;
  const url = new URL(accountUrl);
  if (typeof location !== 'undefined') {
    var _location$pathname;
    if (location.origin === accountUrl && (_location$pathname = location.pathname) != null && _location$pathname.includes('/missinginfo')) {
      return;
    }
    url.searchParams.append('redirect_uri', location.href);
    url.pathname = `/${path}`;
    location.href = url.href;
  }
};
const [UserContextProvider, useUserContext] = createContext({
  name: 'User'
});
let userChildCache = ['', []];
const UserProvider = ({
  children,
  pictureDomain,
  appName,
  hostAccount
}) => {
  const legacyApi = useApiContext();
  const [user, setUser] = useState(null);
  const [legacyUser, setLegacyUser] = useState(null);
  const [{
    missingInfos,
    error
  }, setError] = useState({});
  const [familyChildren, setChildren] = useState([]);
  const [userInstance] = useState(() => new LegacyUser(legacyApi, pictureDomain, appName));
  const isFamilyAvailable = Boolean((user == null ? void 0 : user.familyStatus.isActive) && (user == null ? void 0 : user.familyStatus.isEnabled));
  function fetchChildren() {
    return _fetchChildren.apply(this, arguments);
  }
  function _fetchChildren() {
    _fetchChildren = _asyncToGenerator(function* (noCache = false) {
      if (!user || !isFamilyAvailable) return;
      let newChildren = [];
      if (!noCache && userChildCache[0] === user.id) {
        newChildren = userChildCache[1];
      } else {
        newChildren = yield userInstance.fetchChildren();
        userChildCache = [user.id, newChildren];
      }
      setChildren(newChildren);
    });
    return _fetchChildren.apply(this, arguments);
  }
  function switchToChild(_x) {
    return _switchToChild.apply(this, arguments);
  }
  function _switchToChild() {
    _switchToChild = _asyncToGenerator(function* (userId) {
      if (!user || !isFamilyAvailable) return;
      return userInstance.switchFamilyProfile(userId);
    });
    return _switchToChild.apply(this, arguments);
  }
  function refetchUser() {
    return userInstance.initialize();
  }
  useEffect(() => {
    function setUserFromService() {
      setUser(userInstance.user);
      setError({});
      setLegacyUser(userInstance.legacyUser);
    }
    function setUserErrorFromService() {
      var _userInstance$missing;
      setError({
        error: userInstance.error,
        missingInfos: userInstance.missingInfos
      });
      if ((_userInstance$missing = userInstance.missingInfos) != null && _userInstance$missing.length) {
        redirectToAccount(hostAccount);
      }
    }
    userInstance.addEventListener(LegacyUserEvents.USER_CHANGED, setUserFromService);
    userInstance.addEventListener(LegacyUserEvents.USER_ERROR, setUserErrorFromService);
    userInstance.initialize();
    return () => {
      userInstance.removeEventListener(LegacyUserEvents.USER_CHANGED, setUserFromService);
      userInstance.removeEventListener(LegacyUserEvents.USER_ERROR, setUserErrorFromService);
    };
  }, [hostAccount, userInstance]);
  return /*#__PURE__*/React.createElement(UserContextProvider, {
    value: {
      error,
      familyChildren,
      fetchChildren,
      isFamilyAvailable,
      legacyUser,
      missingInfos,
      refetchUser,
      switchToChild,
      user
    }
  }, children);
};
export default UserProvider;
export const useUser = () => {
  const {
    user,
    missingInfos,
    refetchUser,
    error
  } = useUserContext();
  return [user, {
    refetchUser,
    missingInfos,
    error
  }];
};

/**
 * @deprecated This hook should only be used if you need access to currently untyped unformated getUserData information
 */
export const useLegacyUser = () => {
  const {
    legacyUser,
    missingInfos,
    refetchUser,
    error
  } = useUserContext();
  return [legacyUser, {
    refetchUser,
    missingInfos,
    error
  }];
};
export const useFamilyUser = () => {
  const {
    user,
    refetchUser,
    familyChildren: children,
    fetchChildren: refetchChildren,
    isFamilyAvailable,
    switchToChild
  } = useUserContext();
  useEffect(() => {
    if (!isFamilyAvailable || !user) return;
    refetchChildren();
  }, [user, isFamilyAvailable, refetchChildren]);
  return [user, children, {
    switchFamilyProfile: switchToChild,
    /** The exposed refetchChildren method forces no cache by default
     * as this is the most common use case for consumer to demand a
     * children refething */
    refetchChildren: (noCache = true) => refetchChildren(noCache),
    refetchUser
  }];
};
//# sourceMappingURL=index.js.map